var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.147,
    height: 18.143,
    viewBox: "0 0 18.147 18.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(0 -0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38167",
    "data-name": "Group 38167",
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38166",
    "data-name": "Group 38166",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58489",
    "data-name": "Path 58489",
    d: "M15.494,2.723a9.071,9.071,0,1,0,0,12.835A9.087,9.087,0,0,0,15.494,2.723ZM14.5,14.564a7.67,7.67,0,1,1,0-10.847A7.679,7.679,0,0,1,14.5,14.564Z",
    transform: "translate(0 -0.07)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38169",
    "data-name": "Group 38169",
    transform: "translate(5.928 5.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38168",
    "data-name": "Group 38168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58490",
    "data-name": "Path 58490",
    d: "M173.414,169.988,171.424,168l1.99-1.987a.7.7,0,1,0-.994-.995l-1.992,1.989-1.992-1.989a.7.7,0,1,0-.994.995l1.99,1.987-1.99,1.987a.7.7,0,0,0,.994.995l1.992-1.989,1.992,1.989a.7.7,0,1,0,.994-.995Z",
    transform: "translate(-167.236 -164.813)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.13a49a53.svg";
export { ForwardRef as ReactComponent };